<template>
    <el-tooltip class="tool-tips" effect="dark" placement="right">
      <div class="tool-tips-content" slot="content">{{tips}}</div>
      <i class="el-icon-question"></i>
    </el-tooltip>
</template>

<script>
export default {
  props: ['tips']
}
</script>

<style lang="scss" scoped>
    .tool-tips{
        margin-left: 5px;
        vertical-align: top;
        padding-top: 10px;
    }
    .tool-tips-content{
        max-width: 300px;
    }
    i{
        cursor: pointer;
        font-size: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/basics/lbToolTips.vue